/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListServicesRequest = {
  state?: components.ComputeResourceState | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type ListServicesResponse =
  | components.ComputeServiceList
  | components.ComputeErrorEnvelope;

/** @internal */
export const ListServicesRequest$inboundSchema: z.ZodType<
  ListServicesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  state: components.ComputeResourceState$inboundSchema.optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListServicesRequest$Outbound = {
  state?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListServicesRequest$outboundSchema: z.ZodType<
  ListServicesRequest$Outbound,
  z.ZodTypeDef,
  ListServicesRequest
> = z.object({
  state: components.ComputeResourceState$outboundSchema.optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listServicesRequestToJSON(
  listServicesRequest: ListServicesRequest,
): string {
  return JSON.stringify(
    ListServicesRequest$outboundSchema.parse(listServicesRequest),
  );
}
export function listServicesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListServicesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListServicesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListServicesRequest' from JSON`,
  );
}

/** @internal */
export const ListServicesResponse$inboundSchema: z.ZodType<
  ListServicesResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  components.ComputeServiceList$inboundSchema,
  components.ComputeErrorEnvelope$inboundSchema,
]);
/** @internal */
export type ListServicesResponse$Outbound =
  | components.ComputeServiceList$Outbound
  | components.ComputeErrorEnvelope$Outbound;

/** @internal */
export const ListServicesResponse$outboundSchema: z.ZodType<
  ListServicesResponse$Outbound,
  z.ZodTypeDef,
  ListServicesResponse
> = z.union([
  components.ComputeServiceList$outboundSchema,
  components.ComputeErrorEnvelope$outboundSchema,
]);

export function listServicesResponseToJSON(
  listServicesResponse: ListServicesResponse,
): string {
  return JSON.stringify(
    ListServicesResponse$outboundSchema.parse(listServicesResponse),
  );
}
export function listServicesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListServicesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListServicesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListServicesResponse' from JSON`,
  );
}
